module.exports = __webpack_public_path__ + "static/media/chart-fire-causes.f190210e.png";